// extracted by mini-css-extract-plugin
export default {"slickSlider":"cAHNfxeA1","feature":"cC7wxVR20","featuresContainerOuter":"cf1xAwSg9","featuresContainer":"cBTMvy8Tb"};